import {EntityType, PropertyDefinition, PropertyDefinitionConfig} from '../types';
import {REPOSITORY_REPOSITORY} from './repository';

export const TEMPLATE_PROPERTY_BELONGS_TO_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idPropertyDefinitionBelongsToRepository',
	singular: 'Reference Field',
	summary: 'Reference to one or many entries in another collection.',
};

export const TEMPLATE_PROPERTY_BELONGS_TO_TEMPLATE_PROPERTIES: PropertyDefinition[] = [{
	id: 'idPropertyDefinitionBelongsToLabelProperty',
	parentId: TEMPLATE_PROPERTY_BELONGS_TO_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'label',
	label: 'Label',
	required: true,
	autoFocus: true,
}, {
	id: 'idPropertyDefinitionBelongsToSlugProperty',
	parentId: TEMPLATE_PROPERTY_BELONGS_TO_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'slug',
	label: 'Key',
	required: true,
	disabled: true,
}, {
	id: 'idPropertyDefinitionBelongsToTargetRepositoryIdProperty',
	parentId: TEMPLATE_PROPERTY_BELONGS_TO_REPOSITORY.id,
	type: EntityType.PropertyDefinitionBelongsTo,
	slug: 'targetRepositoryId',
	targetRepositoryId: REPOSITORY_REPOSITORY.id,
	label: 'Other collection',
	required: true,
}, {
	id: 'idPropertyDefinitionBelongsToRequiredProperty',
	parentId: TEMPLATE_PROPERTY_BELONGS_TO_REPOSITORY.id,
	type: EntityType.PropertyDefinitionBoolean,
	slug: 'required',
	label: 'Required',
	required: true,
}, {
	id: 'idPropertyDefinitionBelongsToAllowManyProperty',
	parentId: TEMPLATE_PROPERTY_BELONGS_TO_REPOSITORY.id,
	type: EntityType.PropertyDefinitionBoolean,
	slug: 'allowMany',
	label: 'Allow many',
	required: true,
}];
